import * as Types from '../types';
import { actionTypes } from './constants';

export const addTranslationsAction = (translations: Record<string, string>): Types.IAddTranslationsAction => ({
    type: actionTypes.ADD_TRANSLATIONS,
    payload: { translations }
});

export const setDefaultTranslationsAction = (
    defaultTranslations: Record<string, string>
): Types.ISetDefaultTranslationsAction => ({
    type: actionTypes.SET_DEFAULT_TRANSLATIONS,
    payload: { defaultTranslations }
});

export const showTranslationKeysAction = (show = true): Types.IShowTranslationKeysAction => ({
    type: actionTypes.SHOW_TRANSLATION_KEYS,
    payload: show
});

export const clearTranslationsAction = (): Types.IClearTranslationsAction => ({
    type: actionTypes.CLEAR_TRANSLATIONS
});
